import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'ui-kit-takeat';
import api from '~/services/api';
import { MdDelete, MdEdit } from 'react-icons/md';
import toast from 'react-hot-toast';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import {
  Radio,
  Switch,
  Button as ButtonNew,
  IconDownload,
} from 'takeat-design-system-ui-kit';
import CodeWeight from '~/assets/img/code_by_weight.svg';
import CodePrice from '~/assets/img/code_by_price.svg';
import { useAuth } from '~/context/AuthContext';
import {
  Actions,
  BalanceArea,
  BalanceTable,
  BalanceTableWrapper,
  ConfigPrintArea,
  Container,
  Delete,
  Header,
  Title,
  TypeArea,
  TypeDiv,
} from './style';
import CreateBalance from './Create';
import EditBalance from './Edit';
import { DownloadProductTxt } from './ProductTXT';

function Balances() {
  const [balances, setBalances] = useState([]);
  const [editBalance, setEditBalance] = useState(null);
  const { updateUser, user } = useAuth();

  const getBalances = useCallback(async () => {
    const response = await api.get(`/restaurants/balances`);
    setBalances(response.data);
  }, []);

  const deleteBalance = useCallback(async (id) => {
    if (window.confirm('Tem certeza que deseja deletar essa balança?')) {
      await api.delete(`/restaurants/balances/${id}`);
      toast.success('Balança deletada com sucesso');
      getBalances();
    }
  }, []);

  useEffect(() => {
    getBalances();
  }, []);

  const [isModalRegisterOpen, setIsModalRegisterOpen] = useState(false);
  function toggleModalRegister() {
    setIsModalRegisterOpen(!isModalRegisterOpen);
  }

  const [isModalEditOpen, setIsModalEditOpen] = useState(false);
  function toggleModalEdit() {
    setIsModalEditOpen(!isModalEditOpen);
  }

  const [isModalDownloadTxt, setIsModalDownloadTxt] = useState(false);
  function toggleModalDownloadTxt() {
    setIsModalDownloadTxt(!isModalDownloadTxt);
  }

  function openModalEdit(balance) {
    setEditBalance(balance);
    setIsModalEditOpen(true);
  }

  const [configPrintOpened, setConfigPrintOpened] = useState(
    user?.ean_scale_mode !== 'none'
  );

  function toggleConfigPrintArea() {
    if (configPrintOpened) {
      const newType = {
        ean_scale_mode: 'none',
      };
      updateUser(newType);
    }
    setConfigPrintOpened(!configPrintOpened);
  }

  const [printType, setPrintType] = useState(user?.ean_scale_mode);

  function changePrintType(type) {
    const updateProfile = {
      ean_scale_mode: type,
    };
    updateUser(updateProfile);
    setPrintType(type);
  }

  return (
    <Container>
      <Header>
        <Button onClick={toggleModalRegister} title="Nova Balança" />
      </Header>

      <Modal isOpen={isModalRegisterOpen} toggle={toggleModalRegister}>
        <ModalHeader>Nova Balança</ModalHeader>
        <ModalBody>
          <CreateBalance
            toggle={toggleModalRegister}
            getBalances={getBalances}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={isModalEditOpen} toggle={toggleModalEdit}>
        <ModalHeader>Editar Balança</ModalHeader>
        <ModalBody>
          <EditBalance
            toggle={toggleModalEdit}
            getBalances={getBalances}
            balance={editBalance}
          />
        </ModalBody>
      </Modal>
      <BalanceTableWrapper>
        <BalanceTable borderless>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Porta</th>
              <th>Baud Rate</th>
              <th>Bit Rate</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {balances?.map((balance) => (
              <tr key={balance.id}>
                <td>{balance.name}</td>
                <td>{balance.port_name}</td>
                <td>{balance.baud_rate}</td>
                <td>{balance.bit_rate}</td>
                <td>
                  <Actions>
                    <MdEdit
                      size={20}
                      onClick={() => {
                        openModalEdit(balance);
                      }}
                      color="#90C2E7"
                      title="Editar Balança"
                      style={{ cursor: 'pointer' }}
                    />

                    <Delete onClick={() => deleteBalance(balance.id)}>
                      <MdDelete size={20} />
                    </Delete>
                  </Actions>
                </td>
              </tr>
            ))}
          </tbody>
        </BalanceTable>
      </BalanceTableWrapper>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            marginTop: 16,
          }}
        >
          <Switch
            onChange={toggleConfigPrintArea}
            checked={configPrintOpened}
            label="Ativar código de barra por balança etiquetadora"
          />
        </div>
        <div
          style={{
            alignContent: 'center',
            marginTop: 16,
          }}
        >
          <ButtonNew
            icon={<IconDownload />}
            onClick={toggleModalDownloadTxt}
            variant="outlined"
          >
            Download Produtos em TXT
          </ButtonNew>

          <DownloadProductTxt
            open={isModalDownloadTxt}
            onClose={toggleModalDownloadTxt}
          />
        </div>
      </div>

      {configPrintOpened && (
        <ConfigPrintArea>
          <Title>
            <p>Escolha o modelo de operação da Balança</p>
            <span>
              Verifique se sua balança está imprimindo código EAN por preço ou
              peso.
            </span>
          </Title>
          <TypeArea>
            <TypeDiv>
              <div style={{ display: 'flex', gap: 16 }}>
                <Radio
                  onClick={() => changePrintType('weight')}
                  value={printType}
                  checked={printType === 'weight'}
                />
                <div>
                  <p>Por peso</p>
                  <span>
                    Nesse caso, os dígitos finais do código EAN representam o
                    peso.
                  </span>
                </div>
              </div>
              <img
                src={CodeWeight}
                title="Imagem de código de barras por peso"
              />
            </TypeDiv>
            <TypeDiv>
              <div style={{ display: 'flex', gap: 16 }}>
                <Radio
                  onClick={() => changePrintType('price')}
                  value={printType}
                  checked={printType === 'price'}
                />
                <div>
                  <p>Por preço</p>
                  <span>
                    Nesse caso, os dígitos finais do código EAN representam o
                    preço.
                  </span>
                </div>
              </div>
              <img
                src={CodePrice}
                title="Imagem de código de barras por preço"
              />
            </TypeDiv>
          </TypeArea>
        </ConfigPrintArea>
      )}
    </Container>
  );
}

export default Balances;
